import { h, Host } from "@stencil/core";
/**
 * @slot (default) - Content of the sidebar
 */
export class AppHeader {
    constructor() {
        this.baseClass = "uxc-app-sidebar-notifications";
        /** Flag that indicates if the app sidebar notification is opened or not */
        this.opened = false;
        /** On which side should the sidebar be positioned */
        this.side = "right";
        /** Flag that indicates if the sidebar top should be aligned with a header */
        this.alignHeader = true;
        /** Flag that indicates if the sidebar bottom should be aligned with a footer */
        this.alignFooter = false;
    }
    componentDidLoad() {
        this.appSidebarNotificationsEvent.emit();
    }
    render() {
        const { baseClass, opened, side, alignHeader, alignFooter } = this;
        return (h(Host, { key: '036334162fa83633edc6a2bbf16e72e561663b69', class: {
                [`${baseClass}`]: true
            } }, h("uic-sidebar", { key: '824bd81763d07b4fba2095902cb47356e69aacac', opened: opened, side: side, alignHeader: alignHeader, alignFooter: alignFooter }, h("div", { key: '1ad973908176edd51725ae88ba608a9d711f8ab9', class: `${baseClass}__inner` }, h("slot", { key: '3c5f6aed3e703595ab26b6b214406cc85829be07' })))));
    }
    static get is() { return "uxc-app-sidebar-notifications"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-sidebar-notifications.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-sidebar-notifications.css"]
        };
    }
    static get properties() {
        return {
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the app sidebar notification is opened or not"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "attribute": "opened",
                "defaultValue": "false"
            },
            "side": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"left\" | \"right\"",
                    "resolved": "\"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "On which side should the sidebar be positioned"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "attribute": "side",
                "defaultValue": "\"right\""
            },
            "alignHeader": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar top should be aligned with a header"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "attribute": "align-header",
                "defaultValue": "true"
            },
            "alignFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar bottom should be aligned with a footer"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "attribute": "align-footer",
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "appSidebarNotificationsEvent",
                "name": "uicAppSidebarNotifications",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the sidebar is loaded. This event informs the app header that\nthe notification bell icon controls the opened state of the sidebar."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-sidebar-notifications.js.map
